import { Grid } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import FiltersContext from '../../contexts/FiltersContext';
import StoryContext from '../../contexts/StoryContext';
import SubquestionBox from '../SubquestionBox';
import NSHInfographic from './NSHInfographic';
import PercentOfNSHRequests from './PercentOfNSHRequests';
import ErrorBoundary from '../ErrorBoundary';

function Q3Row1() {
  const [familyType, setFamilyType] = useState('All');
  const [settingType, setSettingType] = useState('All');
  const [childAge, setChildAge] = useState('All');

  const { lightColor } = useContext(StoryContext);

  return (
    <FiltersContext.Provider value={{
      familyType, setFamilyType, settingType, setSettingType, childAge, setChildAge,
    }}
    >
      <SubquestionBox color={lightColor}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <ErrorBoundary>
              <NSHInfographic />
            </ErrorBoundary>
          </Grid>
          <Grid item xs={12} sm={6}>
            <ErrorBoundary>
              <PercentOfNSHRequests />
            </ErrorBoundary>
          </Grid>
        </Grid>
      </SubquestionBox>
    </FiltersContext.Provider>
  );
}

export default Q3Row1;
